var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditStock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2994_67823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4168 50.0962H6.25C2.80418 50.0962 0 47.2921 0 43.8462V14.6794C0 11.2336 2.80418 8.42944 6.25 8.42944H22.9168C24.0688 8.42944 25 9.3629 25 10.513C25 11.6628 24.0688 12.5962 22.9168 12.5962H6.25C5.09987 12.5962 4.16679 13.5316 4.16679 14.6794V43.8462C4.16679 44.9941 5.09987 45.9294 6.25 45.9294H35.4168C36.5665 45.9294 37.5 44.9941 37.5 43.8462V27.1794C37.5 26.0297 38.4312 25.0962 39.5832 25.0962C40.7352 25.0962 41.6668 26.0297 41.6668 27.1794V43.8462C41.6668 47.2921 38.8626 50.0962 35.4168 50.0962Z",
    fill: "#607D8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.017 6.71484L19.5334 23.1982C19.3876 23.3439 19.2896 23.5293 19.248 23.7292L17.7752 31.0961C17.7065 31.4375 17.8148 31.7896 18.0605 32.0376C18.2585 32.2355 18.5251 32.3416 18.7983 32.3416C18.8646 32.3416 18.9337 32.3355 19.0023 32.321L26.367 30.8481C26.5711 30.8062 26.7565 30.7085 26.9003 30.5624L43.3836 14.0791L36.017 6.71484Z",
    fill: "#42A5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4753 1.62115C46.4444 -0.410175 43.1401 -0.410175 41.1107 1.62115L38.2275 4.5043L45.5922 11.869L48.4753 8.98542C49.4588 8.00428 50.0005 6.69584 50.0005 5.30424C50.0005 3.91264 49.4588 2.6042 48.4753 1.62115Z",
    fill: "#42A5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2994_67823"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditStock);
export default __webpack_public_path__ + "static/media/editStock.7c408df7ebab40e3e627b68930b53a37.svg";
export { ForwardRef as ReactComponent };